




















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { MungBeanAllocatePreview, MungBeanAllocateExecute } from '@/api'
import { ElForm } from 'element-ui/types/form'

@Component({
  methods: {
    handleRefreshPreview(this: MungBeanAllocateRechargeDialog) {
      this.fetchPreview()
    },
    onAmountInput(this: MungBeanAllocateRechargeDialog) {
      this.schedulePreviewDebounced()
    },
    handleClose(this: MungBeanAllocateRechargeDialog) {
      this.close()
    },
    handleSave(this: MungBeanAllocateRechargeDialog) {
      this.save()
    },
  },
})
export default class MungBeanAllocateRechargeDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  private show = false
  private saving = false
  private previewLoading = false
  private previewError = ''
  private preview: any = null
  private previewTimer: any = null

  private form: any = {
    targetUserId: undefined,
    userLabel: '',
    directPool: '',
    tenGenPool: '',
    directNonIdentityQty: '',
    note: '',
  }

  private rules = {
    directPool: [{ required: true, message: '请输入直推分配金额', trigger: 'blur' }],
    tenGenPool: [{ required: true, message: '请输入十代分配总金额', trigger: 'blur' }],
  }

  get showDirectNonIdentity() {
    return this.preview && this.preview.directReferrerExists && !this.preview.directReferrerHasIdentity
  }

  get poolInputSum() {
    const d = parseFloat(String(this.form.directPool)) || 0
    const t = parseFloat(String(this.form.tenGenPool)) || 0
    return (d + t).toFixed(2)
  }

  get canExecute() {
    const d = parseFloat(String(this.form.directPool)) || 0
    const t = parseFloat(String(this.form.tenGenPool)) || 0
    return !!this.preview && !this.previewError && !this.previewLoading && (d > 0 || t > 0)
  }

  public open(data: any) {
    this.show = true
    const uid = data && (data.id != null ? data.id : data.userId)
    this.form.targetUserId = uid
    this.form.userLabel = `${uid} / ${(data && data.nickname) || '-'} / ${(data && data.mobilePhone) || '-'}`
    this.form.directPool = ''
    this.form.tenGenPool = ''
    this.form.directNonIdentityQty = ''
    this.form.note = ''
    this.preview = null
    this.previewError = ''
    this.$nextTick(() => {
      this.fetchPreview()
    })
  }

  private close() {
    this.show = false
    if (this.previewTimer) {
      clearTimeout(this.previewTimer)
      this.previewTimer = null
    }
  }

  private schedulePreviewDebounced() {
    if (this.previewTimer) {
      clearTimeout(this.previewTimer)
    }
    this.previewTimer = setTimeout(() => {
      this.fetchPreview()
    }, 400)
  }

  private buildPayload() {
    const directStr = String(this.form.directPool == null ? '' : this.form.directPool).trim()
    const tenStr = String(this.form.tenGenPool == null ? '' : this.form.tenGenPool).trim()
    const directPool = directStr === '' ? 0 : parseFloat(directStr)
    const tenGenPool = tenStr === '' ? 0 : parseFloat(tenStr)
    const payload: any = {
      targetUserId: this.form.targetUserId,
      directPool: Number.isNaN(directPool) ? 0 : directPool,
      tenGenPool: Number.isNaN(tenGenPool) ? 0 : tenGenPool,
      note: this.form.note || undefined,
    }
    if (this.showDirectNonIdentity && this.form.directNonIdentityQty !== '') {
      const v = parseFloat(String(this.form.directNonIdentityQty).trim())
      payload.directNonIdentityQty = Number.isNaN(v) ? 0 : v
    }
    return payload
  }

  /** 试算请求（须在 methods 或 public 中供模板/装饰器 methods 调用） */
  public async fetchPreview() {
    const targetUserId = this.form.targetUserId
    if (targetUserId == null || targetUserId === '') {
      this.previewError = '标的用户ID无效，请关闭弹窗后从用户列表重新打开'
      return
    }
    this.previewLoading = true
    this.previewError = ''
    try {
      const payload = this.buildPayload()
      const res = await MungBeanAllocatePreview(payload)
      if (!res) {
        this.preview = null
        this.previewError =
          '试算失败：请确认已执行 update-26-06-18-mung_bean_allocate.sql 中的十代比例配置（mung_bean_allocate_ten_gen_ratio_1~10 合计100%）'
        return
      }
      this.preview = res
    } catch (e: any) {
      this.preview = null
      this.previewError = (e && e.message) || '试算失败'
    } finally {
      this.previewLoading = false
    }
  }

  private async save() {
    const f = this.$refs.formRef as ElForm
    f.validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      await this.fetchPreview()
      if (!this.canExecute) {
        return
      }
      this.saving = true
      try {
        const res = await MungBeanAllocateExecute(this.buildPayload())
        this.$message.success('分配成功，批次号：' + (res && res.batchNo ? res.batchNo : ''))
        this.close()
        this.$emit('success')
      } finally {
        this.saving = false
      }
    })
  }
}
